import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { LocationTreeList } from 'types/api'

export const locationsQueryKey = ['locations']

export function useLocations() {
  async function getLocations() {
    const response = await apiClient.get<LocationTreeList[]>(
      SNA_PREFIX + `locations/tree-list`
    )

    return response.data
  }

  return useQuery({
    queryFn: getLocations,
    queryKey: locationsQueryKey
  })
}
